module.exports = __webpack_public_path__ + "static/home_header_3-0aebf030308ddbb58f8954423f0ac7eb.png";